// from https://github.com/microsoft/fluentui/packages/utilities

let _isServer = typeof window === 'undefined';

/**
 * The function to determine whether if it is running in server side or not.
 *
 * @public
 */
export function isServer(): boolean {
  return _isServer;
}

/**
 * Helper to set the indicator `isServer` to simulate no window object returned from `getWindow()` helper.
 *
 * @public
 */
export function setServer(value: boolean): void {
  _isServer = value;
}

// aliases
export { isServer as isSSR, setServer as setSSR };
